var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal fade modal-upload", attrs: { id: "modalDelete" } },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-body" }, [
            _c(
              "button",
              {
                staticClass: "close",
                attrs: { type: "button", "data-dismiss": "modal" }
              },
              [_vm._v("×")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "center-modal" }, [
              _c(
                "div",
                {
                  staticClass:
                    "center-ttl font300 d-flex justify-content-center"
                },
                [
                  _c("i", { staticClass: "icon-trash-g mr-2 mt-1" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "font500 text-pink" }, [
                    _vm._v(_vm._s(_vm.$t("voucher.delete.confirm")))
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "row mt-4 no-gutters" }, [
                _c("div", { staticClass: "col-6 pr-2" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-pink-53 w-100",
                      attrs: {
                        "data-dismiss": "modal",
                        "data-toggle": "modal"
                      },
                      on: { click: _vm.deleteVoucher }
                    },
                    [_vm._v(_vm._s(_vm.$t("button.ok")))]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 pl-2" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-gray-53 w-100",
                      attrs: { "data-dismiss": "modal" }
                    },
                    [_vm._v(_vm._s(_vm.$t("button.cancel")))]
                  )
                ])
              ])
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6af09e96", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6af09e96","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/pc/Voucher/DeleteVoucher.vue
// module id = null
// module chunks = 